<td class="align-center">
  <label class="checkbox-style">
    <input
      class="checkbox"
      type="checkbox"
      (change)="onHeaderCheckClick($event, header)"
      [checked]="allChecked(header)"
    />
    <span class="checkmark"></span>
  </label>
  <button
    *ngIf="headersHaveItems"
    class="toggle-show-sub-table"
    (click)="toggleItems()"
  >
    <div class="svgs">
      <svg *ngIf="!header.showItems" class="toggle-show-sub-table__open">
        <use href="#plus-circle" />
      </svg>
      <svg *ngIf="header.showItems" class="toggle-show-sub-table__close">
        <use href="#minus-circle" />
      </svg>
    </div>
  </button>
</td>
<td *ngFor="let column of _columnConfig" class="cell-icons">
  <div class="icons-wrapper">
    <tmnz-tool-tip
      *ngIf="column.notesCallBack && header.notes"
      class="icon"
      (click)="column.notesCallBack(header)"
      [iconName]="'transaction-notes'"
    >
      {{ header.notes }}
    </tmnz-tool-tip>
    <span class="{{ column.classOverride }}">
      {{ header[column.key] | cellcontent: column.type:column.resolver:header }}
    </span>
  </div>
</td>
<ng-container *ngIf="actions !== null">
  <td
    class="dropdown runManagementActionsCell align-right table__priority-column"
    dropdown
  >
    <button dropdownToggle class="icon icon-kog dropdownToggle"></button>
    <ul class="dropdown-menu" aria-labelledby="angular-simple-dropdown">
      <li class="dropdown-item" *ngFor="let action of actions[header.runId]">
        <button
          class="menu__button"
          (click)="action.callback(action.args)"
          [innerHTML]="action.actionText"
        ></button>
      </li>
    </ul>
  </td>
</ng-container>
